module.exports = __webpack_public_path__ + "media/images/magna-partner-99f69b3e9bb8e25be4bbcdd7483548b5.png";